import { useState, useEffect } from 'react'
import ScrollableScreen from '@/components/ui/ScrollableScreen'

export default function ChangelogPage() {
    const [changelog, setChangelog] = useState(null)

    useEffect(() => {
        fetch('/changelog.json')
            .then((res) => res.json())
            .then((data) => setChangelog(data))
    }, [])

    const breadcrumbs = [{ label: 'Nouveautés' }]

    // Extraire le texte d'un item (string ou objet)
    const getItemText = (item) => {
        return typeof item === 'object' ? item.text : item
    }

    const isMajor = (item) => {
        return typeof item === 'object' && item.major
    }

    return (
        <ScrollableScreen breadcrumbs={breadcrumbs}>
            <div className="max-w-3xl mx-auto px-6 py-10">
                {/* Header */}
                <div className="text-center mb-12">
                    <h1 className="text-3xl font-serif italic text-gray-900 mb-2">
                        Nouveautés
                    </h1>
                    <p className="text-gray-500">
                        Mises à jour, améliorations et corrections
                    </p>
                </div>

                {/* Timeline */}
                <div className="relative">
                    {changelog?.entries?.map((entry, index) => (
                        <div key={index} className="relative flex pb-12">
                            {/* Colonne gauche : date */}
                            <div className="w-28 shrink-0 text-right pr-6 pt-0.5">
                                <span className="text-sm font-medium text-blue-600">
                                    {entry.period}
                                </span>
                            </div>

                            {/* Colonne centrale : timeline */}
                            <div className="flex flex-col items-center">
                                <div className="w-2.5 h-2.5 rounded-full bg-blue-600 shrink-0" />
                                {index < changelog.entries.length - 1 && (
                                    <div className="w-px flex-1 bg-gray-200" />
                                )}
                            </div>

                            {/* Colonne droite : contenu */}
                            <div className="flex-1 pl-6">
                                {/* Points marquants */}
                                {entry.features?.filter(isMajor).length > 0 && (
                                    <div className="mb-5 pl-4 border-l-2 border-blue-500">
                                        <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                            Points marquants
                                        </h3>
                                        <ul className="space-y-1.5 list-disc pl-4 marker:text-gray-400">
                                            {entry.features
                                                .filter(isMajor)
                                                .map((item, i) => (
                                                    <li
                                                        key={i}
                                                        className="text-gray-700 text-sm pl-1"
                                                    >
                                                        {getItemText(item)}
                                                    </li>
                                                ))}
                                        </ul>
                                    </div>
                                )}

                                {/* Fonctionnalités */}
                                {entry.features?.filter((f) => !isMajor(f))
                                    .length > 0 && (
                                    <div className="mb-5">
                                        <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                            Fonctionnalités
                                        </h3>
                                        <ul className="space-y-1.5 list-disc pl-4 marker:text-gray-400">
                                            {entry.features
                                                .filter((f) => !isMajor(f))
                                                .map((item, i) => (
                                                    <li
                                                        key={i}
                                                        className="text-gray-600 text-sm pl-1"
                                                    >
                                                        {getItemText(item)}
                                                    </li>
                                                ))}
                                        </ul>
                                    </div>
                                )}

                                {/* Corrections */}
                                {entry.fixes?.length > 0 && (
                                    <div className="mb-5">
                                        <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                            Corrections
                                        </h3>
                                        <ul className="space-y-1.5 list-disc pl-4 marker:text-gray-400">
                                            {entry.fixes.map((item, i) => (
                                                <li
                                                    key={i}
                                                    className="text-gray-600 text-sm pl-1"
                                                >
                                                    {getItemText(item)}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {/* Améliorations */}
                                {entry.improvements?.length > 0 && (
                                    <div className="mb-5">
                                        <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                            Améliorations
                                        </h3>
                                        <ul className="space-y-1.5 list-disc pl-4 marker:text-gray-400">
                                            {entry.improvements.map(
                                                (item, i) => (
                                                    <li
                                                        key={i}
                                                        className="text-gray-600 text-sm pl-1"
                                                    >
                                                        {getItemText(item)}
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                {!changelog && (
                    <div className="text-center text-gray-500 py-10">
                        Chargement...
                    </div>
                )}
            </div>
        </ScrollableScreen>
    )
}
